import React, { Component } from "react";
import { connect } from "react-redux";

import { Switch, Route } from "react-router-dom";
import {
  showBackButton,
  getUserForAuth,
  logoutUser,
} from "../../../actions/authAction";

import PropComCreate from "./PropComCreate";

import PropComDetail from "./PropComDetail";

import PropComSaleSearchList from "./PropComSaleSearchList";

import PropComRentSearchList from "./PropComRentSearchList";

class PropComDashboard extends Component {
  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.getUserForAuth();
    }
    if (this.props.history.location.pathname !== "/") {
      this.props.showBackButton();
    }
  }
  onLogoutClick = () => {
    this.props.logoutUser();
  };
  render() {
    return (
      <div className="font-family-Roboto">
        <div style={{}} className="maindiv bgColor-gr1">
          <Switch>
            <Route
              exact
              path="/ggn/propcom/PropComCreate"
              component={PropComCreate}
            />
            <Route
              exact
              path="/ggn/propcom/PropComDetail/:id"
              component={PropComDetail}
            />

            <Route
              exact
              path="/ggn/propcom/PropComSaleSearchList"
              component={PropComSaleSearchList}
            />

            <Route
              exact
              path="/ggn/propcom/PropComRentSearchList"
              component={PropComRentSearchList}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log("state_comDashboard", state);
  return {
    auth: state.auth,
    state,
  };
};

export default connect(
  mapStateToProps,

  {
    showBackButton,
    getUserForAuth,
    logoutUser,
  }
)(PropComDashboard);
